import angular from 'angular';

angular.module('commonServices').filter('showContactData', function() {
  return function(contactId, contactList) {
    for (var t = 0; t < contactList.length; t++) {
      if (contactList[t].target.id === contactId) {
        return contactList[t].target;
      }
    }
    return null;
  };
});
